import React from 'react';
import Layout from "../components/Layout/Layout";

const Register = () => {
    return (
        <Layout>

        </Layout>
    );
};

export default Register;